<template>
  <div class="mc-trackvideo-card__item mc-trackvideo-card__item--nochoice">
    <div class="mc-trackvideo-card__item-wrapper">
      <div class="mc-trackvideo-card-body">
        <div class="mc-trackvideo-card-body-content">
          <NoVideo />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NoVideo from './NoVideo'

export default {
  components: {
    NoVideo,
  },
}
</script>
